/**
 *
 * @module entry
 * @desc {SDK.Subscription} entry point.
 *
 */

import SubscriptionApi from './subscriptionApi';
import SubscriptionManager from './subscriptionManager';

import Product from './product';
import ProductEntitlement from './productEntitlement';
import ProductStatus from './productStatus';
import Subscription from './subscription';
import SubscriptionProvider from './subscriptionProvider';
import SubscriptionSource from './subscriptionSource';

/**
 *
 * @typedef SDK.Subscription
 * @type {Object}
 *
 * @property {SubscriptionApi} SubscriptionApi
 * @property {SubscriptionManager} SubscriptionManager
 *
 * @property {Product} Product
 * @property {ProductEntitlement} ProductEntitlement
 * @property {ProductStatus} ProductStatus
 * @property {Subscription} Subscription
 * @property {SubscriptionProvider} SubscriptionProvider
 * @property {SubscriptionSource} SubscriptionSource
 *
 */

/**
 *
 * @type {SDK.Subscription}
 *
 */
export default {

    SubscriptionApi,
    SubscriptionManager,

    Product,
    ProductEntitlement,
    ProductStatus,
    Subscription,
    SubscriptionProvider,
    SubscriptionSource

};



// WEBPACK FOOTER //
// ./src/subscription/entry.js